import React, { useState } from 'react'
import { Footer } from '../../components/Footer'
import { LandingPage } from './LandingPage'
import { Step1 } from './Step1'
import { Step2 } from './Step2'
import { Step3 } from './Step3'
import { Step4 } from './Step4'
import { Step5 } from './Step5'
import { EditPage } from './EditPage'
import { FormPage } from './FormPage'
import { ThanksPage } from './ThanksPage'

function UnionClothes() {
  const [step, setStep] = useState(Number(window.localStorage.getItem('Union-step')) || 1)

  const nextStep = () => {
    setStep((step) => step + 1)
  }

  const newProduct = () => {
    setStep(2)
    window.localStorage.removeItem('Union-step')
    window.localStorage.removeItem('Union-clothType')
    window.localStorage.removeItem('Union-color')
  }

  const setPage = (number: number) => {
    setStep(number)
  }

  const onRefresh = () => {
    if (JSON.parse(window.localStorage.getItem('Union-savedUnionItems') || '[]').length) {
      setStep(5)
    } else {
      setStep(1)
    }
  }

  const cancel = () => {
    onRefresh()
    window.localStorage.removeItem('Union-step')
    window.localStorage.removeItem('Union-clothType')
    window.localStorage.removeItem('Union-color')
  }
  return (
    <>
      {/* <div style={{ height: '54px', display: 'flex', justifyContent: 'center', alignItems: 'center', borderBottom: '1px solid #D5D7DD', background: '#fff', boxShadow: '0 0 10px 0 rgb(15 30 61 / 3%)' }}>
        <img style={{ height: '38px', cursor: 'pointer' }} src="https://www.abcgruppen.se/wp-content/uploads/2020/03/abc-logo-220x91.svg" alt="logo" onClick={onRefresh} />
      </div> */}
      {step === 0 && <Step1 nextStep={nextStep} />}
      {step === 1 && <Step1 nextStep={nextStep} />}
      {step === 2 && <Step2 nextStep={nextStep} cancel={cancel} />}
      {step === 3 && <Step3 nextStep={nextStep} setPage={setPage} />}
      {step === 4 && <Step4 nextStep={nextStep} cancel={cancel} />}
      {step === 5 && <Step5 nextStep={nextStep} newProduct={newProduct} setPage={setPage} />}
      {step === 6 && <EditPage setPage={setPage} />}
      {step === 7 && <FormPage setPage={setPage} nextStep={nextStep} />}
      {step === 8 && <ThanksPage />}
      <Footer />
    </>
  )
}

export default UnionClothes

